<ion-header>
  <ion-toolbar class="thin-toolbar background-background" mode="ios">
    <frontend-header routeId="reservations"></frontend-header>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <frontend-pull-refresh></frontend-pull-refresh>

  <div *ngIf="user">
    <div>
      <nav class="navbar navbar-light bg-light header-line-height">
        <ul class="nav nav-pills col-6">
          <li class="nav-item" *ngFor="let item of navItems">
            <a [routerLink]="item.href" class="nav-link lead secondary flex">
              <tr-icon [icon]="item.icon" classes="mr-1"></tr-icon>
              {{item.name}}
            </a>
          </li>
          <li class="nav-item">
            <button *ngIf="reservations.length > 0" (click)="getAllReservations()"
                    class="nav-link lead secondary print-btn flex" [disabled]="isPrinting">
              <tr-icon [icon]="icon.print" classes="w-10 mr-1"></tr-icon>
              <span *ngIf="isPrinting" class="spinner tr-bullet d-flex flex-nowrap justify-content-between align-items-center w-10">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </span>
              Print</button>
          </li>
        </ul>

        <div class="input-group bg-light datepicker-box background-background">
          <button class="btn btn-info btn-icon no-round-right" (click)="datepicker.toggle()">
            <tr-icon [icon]="icon.date" [white]="true"></tr-icon>
          </button>
          <input
            id="reservation-date-input"
            class="form-control no-round-right no-round-left date-input"
            type="text" placeholder="Select date"
            autocomplete="off"
            ngbDatepicker
            container="body"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [weekdays]="true"
            [firstDayOfWeek]="7"
            #datepicker="ngbDatepicker"
            name="date"
            [(ngModel)]="reservationDateFilter"
            (ngModelChange)="changeDate()"
            (click)="datepicker.toggle()" />
          <button class="btn btn-info btn-icon no-round-left" (click)="deleteDate()">
            <tr-icon [icon]="icon.cancel" [white]="true"></tr-icon>
          </button>
        </div>
      </nav>

      <div class="search-row">
        <tablesready-search-bar
          #searchBarRef
          [placeholder]="'Search ' + location?.displayOptions?.labels?.reservation_plural"
          (search)="updateSearchQuery($event)"
        ></tablesready-search-bar>
      </div>

    </div>

    <div style="overflow-x: auto">
      <table *ngIf="reservations.length>0"
             class="table table-striped tr-table table-bottom-spacer"
             id="tableOfReservations"
             #tableOfReservations
             [ngClass]="{'table-sm':displayCompact}" >
        <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col" *ngIf="location?.waitFields.size">Size</th>
          <th scope="col" class="print-minw-180">
            {{location?.displayOptions.labels.customer | titlecase}}</th>
          <th scope="col">Notes</th>
          <th scope="col"
              *ngIf="location?.serviceSettings.enabled && location?.serviceSettings.showOnPages && services.length > 0">
            {{location?.serviceSettings.label}}</th>
          <th scope="col"
              *ngIf="location?.resourceSettings.enabled  && location?.resourceSettings.showOnPages && resources.length > 0">
            {{location?.resourceSettings.label}}</th>
          <ng-container *ngIf="showCustomFieldsData">
            <ng-container *ngFor="let customField of user.location.partyFields">
              <th *ngIf="customField.enabled && customField.visibility.private.view" [innerText]="customField.name"></th>
            </ng-container>
          </ng-container>
          <th scope="col" class="hide-on-print">Actions</th>
        </tr>
        </thead>
        <tbody *ngIf="reservations.length > 0">
        <tr *ngIf="reservations.length > 0">
          <td colspan="1000">
          <span class="lead name">
            {{ reservations[0].quoted_time | trDateFormat:'dddd, MMM D, y': timezone}}
          </span>
          </td>
        </tr>
        <ng-container *ngFor="let res of reservations; index as i; trackBy: trackById">
          <tr *ngIf="!res.isHidden">
            <td>
              <span class="d-xs-inline d-sm-none hide-on-print">Date: </span>
              <span> {{res.quoted_time | trDateFormat:'h:mma': timezone}} </span>
              <span class="d-xs-inline d-sm-none">{{res.quoted_time | trDateFormat:'M/D/yy': timezone}}</span>
            </td>

            <td *ngIf="location.waitFields.size">
              <span class="d-xs-inline d-sm-none hide-on-print">Size: </span>
              {{res.size}}
            </td>

          <td class="print-minw-180">
            <span class="d-block lead name">
              {{res.name}}

              <shared-badge
                *ngIf="unpaid(res)"
                label="Unpaid"
                class="badge badge-pill badge-danger"
              ></shared-badge>
              <shared-badge
                *ngIf="paid(res)"
                label="Paid"
                class="badge badge-pill badge-success"
              ></shared-badge>

              <span *ngIf="unpaid(res)" class="d-flex flex-row">
                <span class="pr-1">
                  Holding for:
                </span>
                <tablesready-countdoun-timer [milliseconds]="getRemainingSecondsToPay(res.created_time)"></tablesready-countdoun-timer>
              </span>
            </span>
            <span *ngIf="paid(res) && res.stripeData?.paymentLink">
              <a class="text-link" [href]="res.stripeData?.paymentLink" target="_blank">Manage Payment</a>
            </span>
            <span *ngIf="res.phone" class="d-block">
              {{res.phone | trTel:location.country:'custom'}}
            </span>
              <span *ngIf="res.loyalty_count >= 1" class="secondary d-block">
              {{res.loyalty_count}} recent visits
            </span>
              <span class="d-block">Added {{res.created_time | trDateFormat:'M/D/yy, h:mm a': timezone}}</span>
              <span *ngIf="res.confirmed_time" class="d-block">
              Confirmed {{res.confirmed_time | trDateFormat:'M/D/yy, h:mm a': timezone}}
            </span>
              <span *ngIf="res.checkin_time" class="d-block">
              Checked In ({{ (now - res.checkin_time) | trTimeDelta }} ago)
            </span>
            </td>

            <td>
              <span class="d-xs-inline d-sm-none hide-on-print">Notes: </span>
              {{ isArray(res.note) ? res.note.join(', ') : res.note}}
              <div
                *ngIf="res.inbounds && res.inbounds.length > 0 || res.notifications && (res.notifications.length > 1 || res.notifications[0]?.status_sent === 'not_sent')">
                <em>Messages:</em>
                <ul class="list-unstyled tr-icon-list mb-1 mt-2">
                  <li
                    *ngFor="let msg of mergeInboundOutbound(res)"
                    [ngClass]="{'danger':!msg.label}"
                    class="d-flex flex-row align-items-center"
                  >
                    <ng-container *ngIf="!msg.label || msg.label === 'chat' || msg?.status_sent === 'not_sent'">
                    <span *ngIf="msg?.status_sent === 'inProcess' && msg?.time >= (now - 60000)"
                          class="spinner tr-bullet d-flex flex-nowrap justify-content-between align-items-center">
                      <div class="bounce1"></div>
                      <div class="bounce2"></div>
                      <div class="bounce3"></div>
                    </span>
                      <i *ngIf="msg?.status_sent === 'sent'" class="bi bi-check tr-bullet"></i>
                      <span
                        *ngIf="msg?.status_sent === 'not_sent' || (msg?.status_sent === 'inProcess' && msg?.time < (now - 60000))"
                        class="bi bi-exclamation-circle-fill tr-bullet"></span>
                      <tr-icon *ngIf="!msg.label" [icon]="icon.send" classes="tr-bullet mr-2"></tr-icon>
                      <span *ngIf="msg.label && msg.label !== 'chat'">
                      {{msg.label | notificationLabel | titlecase}} {{msg.type | prettifyNotificationType}}
                    </span>
                      <span *ngIf="!msg.label || msg.label === 'chat'"
                            [innerHtml]="(msg?.Body || msg?.message)"></span>
                      <span>({{ (now - msg.time) | trTimeDelta }} ago)</span>
                    </ng-container>
                  </li>
                </ul>
              </div>
            </td>
            <td *ngIf="location.serviceSettings.enabled && location.serviceSettings.showOnPages && services.length > 0">
              <tablesready-model-name-display [id]="res.services" [models]="services"></tablesready-model-name-display>

            </td>
            <td *ngIf="location.resourceSettings.enabled && location.resourceSettings.showOnPages && resources.length > 0">
              <tablesready-model-name-display [id]="res.resources" [models]="resources"></tablesready-model-name-display>
            </td>

            <ng-container *ngIf="showCustomFieldsData">
              <ng-container *ngFor="let customField of user.location.partyFields">
                <ng-container *ngIf="customField.enabled && customField.visibility.private.view && displayCustomFieldCell(res, customField.id)">
                  <td
                    *ngIf="customField.type !== fieldTypes.tel"
                    [innerHTML]="res.customFields[customField.id]"
                  ></td>

                  <td
                    *ngIf="customField.type === fieldTypes.tel"
                    [innerText]="res.customFields[customField.id] ? (res.customFields[customField.id] | trTel:location.country:'custom') : ''"
                  ></td>
                </ng-container>
              </ng-container>
            </ng-container>

            <td class="hide-on-print">
              <div class="d-flex flex-nowrap">
                <button
                  container="body"
                  class="btn btn-icon btn-info-outline mr-2"
                  (click)="chatParty(res)"
                  [ngbTooltip]="chatTooltip(res.phone)"
                  [disabled]="!res.phone"
                  (mousedown)="sendIconActive[i] = true"
                  (mouseup)="sendIconActive[i] = false"
                >
                  <tr-icon [icon]="icon.chat" [color]="sendIconActive[i] ? color.white : color.blue" [white]="true"></tr-icon>
                </button>
                <button class="btn btn-icon btn-info mr-2" placement="top" [ngbTooltip]="!isMobile ? 'Edit' : ''" container="body"
                        (click)="addEditReservation(res)">
                  <tr-icon [icon]="icon.edit" [white]="true"></tr-icon>
                </button>
                <button class="btn btn-icon btn-danger mr-2" placement="bottom" [ngbTooltip]="!isMobile ? 'Cancel' : ''" container="body"
                        (click)="confirmDelete(res)" angularticsCategory="reservations" angulartics2On="click"
                        angularticsAction="canceled reservation">
                  <tr-icon [icon]="icon.cancel" [white]="true"></tr-icon>
                </button>
                <button *ngIf="showCheckInButton(res)"
                        class="btn btn-success text-nowrap" (click)="checkIn(res)" angularticsCategory="reservations" angulartics2On="click"
                        angularticsAction="checked-in reservation" [disabled]="isSubmitting">
                  <i class="bi bi-play-fill"></i> Check In
                </button>
              </div>
            </td>
          </tr>
          <tr
            *ngIf="reservations.length-1 > i && (res.quoted_time|trDateFormat:'M/D/yy': timezone) !== (reservations[i+1].quoted_time|trDateFormat:'M/D/yy': timezone)">
            <td colspan="1000">
              <span class="lead name">{{ reservations[i+1].quoted_time | trDateFormat:'dddd, MMM D, y': timezone}}</span>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>

    <div class="col-12" *ngIf="reservations.length===0">
      No upcoming {{location?.displayOptions.labels.reservation_plural}}.
    </div>
  </div>

  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <div class="add-new">
  <span class="add-new-blocker" slot="fixed">
    <button type="button"
            class="btn btn-accent btn-circle"
            (click)="addEditReservation()"
            [ngClass]="{'disabled' : !user || !service.schedule?.length}"
            id="addEditParty-button">
      <tr-icon [icon]="icon.plus" [size]="size.extraLarge" [color]="color.white"></tr-icon>
    </button>
  </span>
  </div>
</ion-content>

<ng-template #canceledMessageTmpl>
  {{getUndoMessage}}
</ng-template>


